(() => {
  function init(scope=document) {
    scope.querySelectorAll('[data-stormy-pack]').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='1';
      const config=JSON.parse(root.querySelector('[data-fan-config]').textContent);
      const form=root.querySelector('form'),button=root.querySelector('[data-fan-order]'),status=root.querySelector('[data-fan-status]');
      if(!form||!button||!status)return;let busy=false;
      const track=(name, detail={})=>{try{window.DroplitFunnel?.track(name,detail);}catch(_){}};
      const quantitySelect=root.querySelector('[data-fan-quantity]');
      const routeRoot=config.root.endsWith('/')?config.root.slice(0,-1):config.root;
      const drawer=root.querySelector('[data-fan-drawer]');
      const drawerEnabled=config.cartDrawer===true&&drawer&&typeof drawer.showModal==='function';
      let drawerLoading=false,previousOverflow='',drawerOpener=null;
      function element(tag,className,text){
        const node=document.createElement(tag);
        if(className)node.className=className;
        if(text!=null)node.textContent=text;
        return node;
      }
      function image(url,alt){
        if(!url)return null;
        let parsed;try{parsed=new URL(url,location.origin);}catch(_){return null;}
        if(parsed.protocol!=='https:')return null;
        const node=element('img');node.src=parsed.href;node.alt=alt;node.loading='lazy';return node;
      }
      function money(cents,currency){return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(cents/100);}
      function renderCart(cart){
        const list=drawer.querySelector('[data-drawer-items]');list.replaceChildren();
        for(const item of cart.items){
          const props=item.properties||{},stormy=props._campaign==='stormy-rain';
          const card=element('article','sr-drawer-card');
          card.append(element('h3','',stormy?'Stormy Rain Fan Pack':item.product_title||item.title));
          const row=element('div','sr-drawer-product');
          let photo=item.image;
          if(stormy){
            const style=String(props['Hat Style']||item.variant_title||'').toLowerCase();
            const key=style.includes('canvas')?'canvas':style.includes('white')?'white':style.includes('black')?'black':null;
            if(key)photo='https://cdn.shopify.com/s/files/1/0809/5963/5641/files/droplit-hat-'+key+'.webp?width=240';
          }
          const img=image(photo,props['Hat Style']||item.product_title||item.title);if(img)row.append(img);
          const detail=element('div');detail.append(element('strong','',props['Hat Style']||item.variant_title||item.title));
          detail.append(element('p','','Qty '+item.quantity+' · '+money(item.final_line_price,cart.currency)));row.append(detail);card.append(row);
          if(stormy){
            const emblems=element('div','sr-drawer-emblems');
            for(const n of [1,2]){
              const label=props['_Drop '+n+' Name']||props['Team Drop '+n]||'Included emblem';
              const emblem=element('div','sr-drawer-emblem');
              const art=image(props['_Drop '+n+' Artwork'],label);if(art)emblem.append(art);
              emblem.append(element('span','',label));emblems.append(emblem);
            }
            card.append(emblems);
            if(props._custom_drop_credit)card.append(element('p','sr-drawer-credit',item.quantity+' free custom emblem credit'+(item.quantity===1?'':'s')+' included · redeem later with free shipping'));
          }
          list.append(card);
        }
        drawer.querySelector('[data-drawer-total]').textContent=money(cart.total_price,cart.currency);
        drawer.querySelector('[data-drawer-checkout]').hidden=cart.item_count===0;
        drawer.querySelector('[data-drawer-status]').textContent=cart.item_count?'':'Your cart is empty. Choose your hat to get started.';
      }
      async function openDrawer(){
        if(drawerLoading)return;
        drawerLoading=true;
        try{
          if(!drawer.open){
            drawerOpener=document.activeElement;previousOverflow=document.body.style.overflow;
            drawer.showModal();document.body.style.overflow='hidden';
          }
          drawer.querySelector('[data-drawer-checkout]').hidden=true;
          drawer.querySelector('[data-drawer-items]').replaceChildren();
          drawer.querySelector('[data-drawer-total]').textContent='—';
          drawer.querySelector('[data-drawer-status]').textContent='Loading your cart…';
          const response=await fetch(routeRoot+'/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
          if(!response.ok)throw Error('Cart unavailable');
          renderCart(await response.json());
          track('cart_viewed',{source:'stormy_drawer'});
        }catch(error){
          if(drawer.open)drawer.querySelector('[data-drawer-status]').textContent='Your items are saved. Open “Edit full cart” below to review them and check out.';
          else location.assign(routeRoot+'/cart');
        }finally{drawerLoading=false;}
      }
      if(drawerEnabled){
        drawer.querySelectorAll('[data-drawer-close]').forEach(close=>close.addEventListener('click',()=>drawer.close()));
        drawer.addEventListener('click',event=>{if(event.target===drawer){const box=drawer.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)drawer.close();}});
        drawer.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;if(drawerOpener&&drawerOpener.isConnected)drawerOpener.focus();});
        const cartLink=root.querySelector('.sr-cart-link');
        if(cartLink)cartLink.addEventListener('click',event=>{if(event.button||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();openDrawer();});
      }

      function update(){
        const selected=form.querySelector('input[name=hat]:checked');if(!selected){button.disabled=true;return;}
        if(root.querySelector('[data-fan-hat]'))root.querySelector('[data-fan-hat]').src='https://cdn.shopify.com/s/files/1/0809/5963/5641/files/droplit-hat-'+selected.value+'.webp?width=900';
        if(root.querySelector('[data-fan-hat]'))root.querySelector('[data-fan-hat]').alt=selected.closest('label').innerText.trim()+' DropLit hat with Stormy Rain emblem';
        if(root.querySelector('.sr-hat-stage'))root.querySelector('.sr-hat-stage').dataset.style=selected.value;
        const quantity=Number(quantitySelect?quantitySelect.value:1);
        const price=root.querySelector('[data-fan-price]');
        const total=selected.getAttribute('data-price-'+quantity);
        if(price){
          price.textContent=total||selected.dataset.price||price.textContent;
          const container=price.closest('.sr-price');
          if(container){
            if(total)container.dataset.totalLabel=quantity===1?'Total · 1 pack':'Total · '+quantity+' packs';
            else delete container.dataset.totalLabel;
          }
        }
        if(quantitySelect)quantitySelect.disabled=busy;
        button.disabled=busy||!config.enabled||!selected.dataset.variant||selected.dataset.available!=='true';
      }
      root.querySelectorAll('[data-fan-drop]').forEach(choice=>choice.addEventListener('click',()=>{
        track('emblem_selected',{emblem:choice.dataset.fanDrop==='two'?'mascot':'team_emblem'});
        const art=root.querySelector('.sr-hat-art img');
        if(art){art.removeAttribute('srcset');art.src=choice.dataset.fanDrop==='two'?config.dropTwo:config.dropOne;art.alt=choice.querySelector('strong').textContent+' on selected hat';}
        root.querySelectorAll('[data-fan-drop]').forEach(item=>item.setAttribute('aria-pressed',String(item===choice)));
      }));
      form.addEventListener('change',event=>{
        update();
        if(event.target.matches('input[name=hat]'))track('hat_selected',{hat:event.target.value});
        if(event.target===quantitySelect)track('quantity_changed',{quantity:Number(quantitySelect.value)});
      });
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(busy||button.disabled)return;
        const selected=form.querySelector('input[name=hat]:checked');if(!selected)return;
        const quantity=Number(quantitySelect?quantitySelect.value:1);
        if(!Number.isInteger(quantity)||quantity<1||quantity>10){track('add_to_cart_blocked',{reason:'invalid_quantity'});status.textContent='Please select between 1 and 10 packs.';return;}
        track('add_to_cart_clicked',{hat:selected.value,quantity});
        let responseStatus=0;
        busy=true;update();status.textContent='Preparing your Fan Pack…';
        try{
          const items=Array.from({length:quantity},()=>{
          const credit=Array.from(crypto.getRandomValues(new Uint8Array(32)),n=>n.toString(16).padStart(2,'0')).join('');
          return {id:Number(selected.dataset.variant),quantity:1,properties:{'Hat Style':({black:'Black Trucker',white:'White Trucker',canvas:'Two-Tone Canvas'})[selected.value],Campaign:'Spike Frog Volleyball — Stormy Rain',Pack:'1 hat + 2 Stormy Rain Drops + 1 custom Drop credit','Team Drop 1':'Stormy Rain emblem','Team Drop 2':'Stormy Rain mascot',_campaign:'stormy-rain','_Drop 1 Artwork':config.dropOne,'_Drop 1 Name':'Stormy Rain emblem','_Drop 2 Artwork':config.dropTwo,'_Drop 2 Name':'Stormy Rain mascot','_DropLit Bundle ID':crypto.randomUUID(),_custom_drop_credit:credit}};
          });
          const response=await fetch(routeRoot+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          responseStatus=response.status;
          if(!response.ok){const detail=await response.json().catch(()=>({}));throw Error(detail.description||'Could not add your pack. Please try again.');}
          track('add_to_cart_success',{hat:selected.value,quantity,status:response.status});
          if(drawerEnabled){busy=false;update();status.textContent='Added to your cart.';await openDrawer();}
          else location.assign(routeRoot+'/cart');
        }catch(error){track('add_to_cart_error',{hat:selected.value,quantity,status:responseStatus,reason:responseStatus?'cart_rejected':'network_or_client_error'});status.textContent=error.message;busy=false;update();}
      });
      window.addEventListener('pageshow',event=>{
        if(!event.persisted||!root.isConnected)return;
        busy=false;
        status.textContent='';
        update();
      });
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();



